import { render } from "./DefaultHeader.vue?vue&type=template&id=61d48cf4"
const script = {}

import "./DefaultHeader.vue?vue&type=style&index=0&id=61d48cf4&lang=css"

import exportComponent from "C:\\Users\\Urakehn\\Documents\\Developpement\\R42\\EasyProf_landing\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__